import Vue from "vue";
import Vuex from "vuex";
import VuexPersistence from "vuex-persist";

Vue.use(Vuex);

const vuexLocal = new VuexPersistence({
  storage: window.localStorage,
});

export default new Vuex.Store({
  state: {
    navSelected: "/login",
    user: {
    },
    userBak: [],
    sysConfig: {},
    courseOrder: {},
    isLogin: false,
    systemSetting: {
      /**  系统设置常量  */
      // ZHCY_MIN_JJSJ("考试最短交卷时间","0"),
      // IS_OPEN_CAMERA("是否开启抓拍", "1"),
      // PHOTO_CATCH_INTERVAL("抓拍间隔时间", "2"),
      // IS_OPEN_VERIFY("是否开启人脸比对", "3"),
      // VERIFY_THRESHOLD("人脸比对阈值", "4");
    },
    studyCourse: {},
    address: {},
    questionDetail: {},
  },
  mutations: {
    selectNav(state, path) {
      state.navSelected = path;
    },
    LOGIN(state, user) {
      state.user = user;
    },
    stateUser(state, student) {
      state.user.student = student;
    },
    ISLOGIN(state, isLogin) {
      state.isLogin = isLogin;
    },
    LOGINBAK(state, user) {
      state.userBak = user;
    },
    SYSCONFIG(state, data) {
      state.sysConfig = data;
    },
    SYSTEMSETTING(state, data) {
      state.systemSetting = data;
    },
    LOGOUT(state) {
      state.user = {};
      state.sysConfig = {};
      state.isLogin = false;
      state.userBak = [];
      state.systemSetting = {};
      state.courseOrder = {};
      state.address = {};
      state.questionDetail = {};
    },
    SET_COURSE(state, studyCourse) {
      state.studyCourse = studyCourse;
    },
    SET_REGINFO(state, regInfo) {
      state.user.regInfo = regInfo;
    },
    UNSET_COURSE(state) {
      state.studyCourse = null;
    },
    CREATE_COURSE_ORDER(state, courseOrder) {
      state.courseOrder = courseOrder;
    },
    DESTROY_COURSE_ORDER(state) {
      state.courseOrder = {};
    },
    setAddress(state, address) {
      state.address = address;
    },
    setQuestionDetail(state, questionDetail) {
      state.questionDetail = questionDetail;
    }
  },
  actions: {},
  modules: {},
  plugins: [vuexLocal.plugin],
});
